export default function reducerOptions () {
  return [
    {
      id: 1,
      name: 'Dashboard',
      url: '',
    },
    {
      id: 2,
      name: 'Users',
      url: 'users',
    },
    {
      id: 3,
      name: 'Compteur',
      url: 'compteur',
    },
    {
      id: 4,
      name: 'Cost',
      url: 'cost',
    },
    {
      id: 5,
      name: 'Appliances',
      url: 'appliances',
    },
    {
      id: 6,
      name: 'Usage By Department',
      url: 'usage-by-department',
    },
    {
      id: 7,
      name: 'Emissions',
      url: 'emissions',
    },
    {
      id: 8,
      name: 'Contact',
      url: 'contact',
    },
  ];
}
